import {
    publicHttpClient,
  } from "madeinusacomponentlibrary/dist/index";
  import configData from "../AppConfig.json";
  
  export class APIClient {
    httpClient: publicHttpClient = new publicHttpClient(configData);
  
    getStates = async () => {
      try {
        const response = await this.httpClient.getStates();
        if (response) {
          response?.forEach((x) => {
            x.key = x.name;
            x.text = x.abbreviation;
          });
        } else {
          return [];
        }
        return response;
      } catch {
        return [];
      }
    };
  
    getCountries = async () => {
      try {
        const response = await this.httpClient.getCountries();
  
        if (response) {
          response?.forEach((x) => {
            x.key = x.name;
            x.text = x.name;
          });
        } else {
          return [];
        }
        return response;
      } catch {
        return [];
      }
    };
  
    getPreferencePrograms = async () => {
      try {
        const response = await this.httpClient.getPreferencePrograms();
        if (response) {
          response?.forEach((x) => {
            x.key = x.name;
            x.text = x.name;
          });
        } else {
          return [];
        }
        return response;
      } catch {
        return [];
      }
    };
  
  getRegions = async () => {
    try {
      const response = await this.httpClient.getRegions();
      if (response) {
        response?.forEach((x) => {
          x.key = x.name;
          x.text = x.name;
        });
      } else {
        return [];
      }
      return response;
    } catch {
      return [];
    }
  };

  getProducts = async () => {
    try {
      const response = await this.httpClient.getProducts();
      if (response) {
        console.log("getProducts", response);
      } else {
        return [];
      }
      return response;
    } catch {
      return [];
    }
  };

  getCurrentCountry = async () => {
    try {
      const response = await this.httpClient.getCurrentCountry();
      if (response) {
        //console.log("getCurrentCountry", response);
      } else {
        return {ip:'',country:''};
      }
      
      return response;
    } catch {
      return {ip:'',country:''};
    }
  };
}